export default __webpack_public_path__ + "static/media/ic_multiswap.e577f4fa.svg";